module.exports = __webpack_public_path__ + "img/but1.79b1ab1f.png";